import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { Playbook } from "../types/playbooks.types";

import { playbooksQueryKeys } from "./queryKeyFactory";

type UsePlaybookQueryParams = {
    playbookId: number;
    enabled?: boolean;
};

export const usePlaybookQuery = ({ playbookId, enabled = true }: UsePlaybookQueryParams) => {
    return useQuery<Playbook>({
        queryKey: playbooksQueryKeys.detail(playbookId),
        queryFn: () => salesApiService.playbooks.fetchPlaybook(playbookId),
        enabled,
    });
};
